export enum EContentBlockOrientation {
  Links = 'links',
  Mitte = 'mitte',
  Rechts = 'rechts'
}
